<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("Précarité") }}</h1>
      <b-button 
        size="sm"
        variant="danger" 
        @click="goBack"
        class="button-succes-style"
      >
        <font-awesome-icon icon="arrow-left" /> {{ $t("Retour") }}
      </b-button>
    </div>

    <div class="content">
      <div class="filtre">
        <p class="table-count">{{ precarites ? precarites.length : 0 }} {{ $t("Précarités") }}</p>
      </div>
      <div class="table-rapport-style w-100">
        <div v-if="getLoadingPrecarite" class="text-center p-4">
          <b-spinner variant="primary" label="Chargement..."></b-spinner>
          <p class="mt-2">{{ $t("Chargement des précarités...") }}</p>
        </div>
        <table v-else>
          <thead>
            <tr>
              <th style="border-radius: 5px 0px 0px 0px">{{ $t("Code département") }}</th>
              <th>{{ $t("Nom département") }}</th>
              <th>{{ $t("Taux précarité") }}</th>
              <th>{{ $t("Taux classique") }}</th>
              <th>{{ $t("Prix cumac précarité") }}</th>
              <th>{{ $t("Prix cumac classique") }}</th>
              <th style="border-radius: 0px 5px 0px 0px" class="action_head">{{ $t("Actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="precarite in precarites" 
              :key="precarite.id"
              role="row"
              class="ligneNormale"
            >
              <td aria-colindex="1" role="cell">{{ precarite.code_departement || "-" }}</td>
              <td aria-colindex="2" role="cell">{{ precarite.nom_departement || "-" }}</td>
              <td aria-colindex="3" role="cell">{{ precarite.taux_precarite ? precarite.taux_precarite + '%' : "-" }}</td>
              <td aria-colindex="4" role="cell">{{ precarite.taux_classique ? precarite.taux_classique + '%' : "-" }}</td>
              <td aria-colindex="5" role="cell">
                <div class="inline-edit">
                  <template v-if="isEditing(precarite.id, 'prix_pr_cumac_classique')">
                    <b-form-input
                      type="number"
                      step="0.01"
                      class="inline-input"
                      v-model="editValues[precarite.id].prix_pr_cumac_classique"
                    ></b-form-input>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 ml-1"
                      @click="confirmEdit(precarite, 'prix_pr_cumac_classique')"
                    >
                      <font-awesome-icon icon="check" />
                    </b-button>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 ml-1"
                      @click="cancelEdit(precarite.id, 'prix_pr_cumac_classique')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-button>
                  </template>
                  <template v-else>
                    <span>{{ precarite.prix_pr_cumac_classique || "-" }}</span>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 ml-1 edit-btn"
                      @click="startEdit(precarite, 'prix_pr_cumac_classique')"
                    >
                      <span class="pen-icon" aria-hidden="true">✎</span>
                    </b-button>
                  </template>
                </div>
              </td>
              <td aria-colindex="6" role="cell">
                <div class="inline-edit">
                  <template v-if="isEditing(precarite.id, 'prix_cumac_classique')">
                    <b-form-input
                      type="number"
                      step="0.01"
                      class="inline-input"
                      v-model="editValues[precarite.id].prix_cumac_classique"
                    ></b-form-input>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 ml-1"
                      @click="confirmEdit(precarite, 'prix_cumac_classique')"
                    >
                      <font-awesome-icon icon="check" />
                    </b-button>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 ml-1"
                      @click="cancelEdit(precarite.id, 'prix_cumac_classique')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-button>
                  </template>
                  <template v-else>
                    <span>{{ precarite.prix_cumac_classique || "-" }}</span>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 ml-1 edit-btn"
                      @click="startEdit(precarite, 'prix_cumac_classique')"
                    >
                      <span class="pen-icon" aria-hidden="true">✎</span>
                    </b-button>
                  </template>
                </div>
              </td>
              <td aria-colindex="7" role="cell" class="action_col">
                <b-button 
                  variant="link" 
                  size="sm" 
                  @click="confirmDelete(precarite)"
                  class="p-0"
                >
                  <font-awesome-icon icon="trash" style="color: red;" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Précarité -->
    <precarite-modal
      :is-open="showModal"
      :update-data="selectedPrecarite"
      @close="closeModal"
      @confirm="handleConfirm"
    />

    <!-- Modal Delete -->
    <b-modal 
      v-model="showDeleteModal" 
      :title="$t('Confirmer la suppression')"
    >
      <p>{{ $t("Êtes-vous sûr de vouloir supprimer cette précarité ?") }}</p>
      
      <template #modal-footer>
        <b-button variant="secondary" @click="showDeleteModal = false">
          {{ $t("Annuler") }}
        </b-button>
        <b-button variant="danger" @click="deletePrecarite">
          {{ $t("Supprimer") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrecariteModal from "@/components/Ajoutmodel/precariteModal.vue";

export default {
  components: {
    PrecariteModal
  },
  computed: {
    ...mapGetters(["getTabs", "getAllPrecarites", "getLoadingPrecarite"]),
    precarites() {
      return this.getAllPrecarites || [];
    }
  },
  data() {
    return {
      showModal: false,
      showDeleteModal: false,
      selectedPrecarite: null,
      editing: {},
      editValues: {},
    };
  },
  async mounted() {
    await this.loadPrecarites();
  },
  methods: {
    ...mapActions(["allPrecarites", "deletedPrecarite", "editPrecarite"]),
    getRoutePrecariteParams() {
      const { configId, entrepriseId } = this.$route.query || {};
      const params = {};
      if (configId) params.configId = configId;
      if (entrepriseId) params.entrepriseId = entrepriseId;
      return params;
    },
    
    async loadPrecarites() {
      try {
        await this.allPrecarites({
          page: 1,
          per_page: 1000,
          ...this.getRoutePrecariteParams(),
        });
      } catch (error) {
        console.error("Erreur lors du chargement des précarités:", error);
      }
    },
    
    goBack() {
      this.$router.go(-1);
    },
    
    openCreateModal() {
      this.selectedPrecarite = null;
      this.showModal = true;
    },
    
    openEditModal(precarite) {
      this.selectedPrecarite = precarite;
      this.showModal = true;
    },
    
    closeModal() {
      this.showModal = false;
      this.selectedPrecarite = null;
    },
    
    async handleConfirm() {
      await this.loadPrecarites();
    },
    
    confirmDelete(precarite) {
      this.selectedPrecarite = precarite;
      this.showDeleteModal = true;
    },
    
    async deletePrecarite() {
      try {
        console.log('Deleting precarite with id:', this.selectedPrecarite.id);
        await this.deletedPrecarite(this.selectedPrecarite.id);
        await this.loadPrecarites();
        this.showDeleteModal = false;
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
      }
    },
    isEditing(id, field) {
      return Boolean(this.editing?.[id]?.[field]);
    },
    startEdit(precarite, field) {
      if (!this.editing[precarite.id]) {
        this.$set(this.editing, precarite.id, {});
      }
      if (!this.editValues[precarite.id]) {
        this.$set(this.editValues, precarite.id, {});
      }
      this.$set(this.editValues[precarite.id], field, precarite[field] ?? "");
      this.$set(this.editing[precarite.id], field, true);
    },
    cancelEdit(id, field) {
      if (this.editing?.[id]) {
        this.$set(this.editing[id], field, false);
      }
    },
    async confirmEdit(precarite, field) {
      if (this.editValues?.[precarite.id]) {
        this.$set(precarite, field, this.editValues[precarite.id][field]);
      }
      await this.savePrix(precarite);
      if (this.editing?.[precarite.id]) {
        this.$set(this.editing[precarite.id], field, false);
      }
    },
    async savePrix(precarite) {
      try {
        const configId = this.$route?.query?.configId;
        const payload = {
          id: precarite.id,
          code_departement: precarite.code_departement,
          nom_departement: precarite.nom_departement,
          taux_precarite: String(precarite.taux_precarite ?? ""),
          taux_classique: String(precarite.taux_classique ?? ""),
          prix_pr_cumac_classique: String(precarite.prix_pr_cumac_classique ?? ""),
          prix_cumac_classique: String(precarite.prix_cumac_classique ?? ""),
        };
        if (precarite.entreprise_id) {
          payload.entreprise_id = precarite.entreprise_id;
        }
        if (configId) {
          payload.configId = configId;
        }
        await this.editPrecarite(payload);
      } catch (error) {
        console.error("Erreur lors de la mise à jour:", error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.button-succes-style {
  margin: 0 2px;
}

.content {
  & p {
    font-size: 12px;
    font-weight: 500;
    padding: 3px 0;
    margin: 0;
  }
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

.inline-edit {
  display: flex;
  align-items: center;
  gap: 4px;
}

.edit-btn {
  color: #24316d;
}

.pen-icon {
  font-size: 12px;
  line-height: 1;
}

.inline-input {
  min-width: 120px;
  font-size: 12px;
  height: 30px;
}

body {
  background: #fafdff;
}

.filtre {
  display: flex;
  align-items: center;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}

::v-deep .modal-content {
  background-color: white !important;
}
</style>